import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";

const accountOptions = [
  {
    label: "Oui",
    value: "yes",
    icon: <FaCheck size={35} color="green" />,
    description:
      "J'ai déjà un compte et j'ai déjà effectué  une opération/souscription.",
  },
  {
    label: "Non",
    value: "no",
    icon: <FaTimes size={35} color="red" />,
    description: "Je suis un nouvel utilisateur, sans compte existant.",
  },
];

function AccountCheck() {
  const navigate = useNavigate();
  const currentStep = "Propriétaire";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];

  const handleOptionSelect = async (option) => {
    if (option === "yes") {
      navigate("/login-workflow");
    } else {
      navigate("/owner-information");
    }
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      {/* Title Section */}
      <div
        className="container mt-4 mb-3 text-center"
        style={{ maxWidth: "800px" }}
      >
        <h4 className="text-2xl font-semibold">
          Avez-vous déjà{" "}
          <span style={{ color: "#FF5500" }}>un compte Platform98</span> ?
        </h4>
        <p
          className="text-center"
          style={{ fontSize: "1.1rem", color: "#555" }}
        >
          Si vous avez déjà créé un compte ou débuté une souscription,
          choisissez <strong>Oui</strong>. Sinon, nous allons vous guider pas à
          pas pour commencer.
        </p>
      </div>

      {/* Option Selection Boxes */}
      <div className="container mt-3 d-flex justify-content-center">
        <div className="row w-100" style={{ maxWidth: "600px" }}>
          {accountOptions.map((option, index) => (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-${index}`}>{option.description}</Tooltip>
              }
            >
              <div className="col-lg-6 mb-4" key={index}>
                <div
                  className="option-box d-flex align-items-center justify-content-center flex-column"
                  onClick={() => handleOptionSelect(option.value)}
                  style={{
                    height: "200px",
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    cursor: "pointer",
                    transition: "border-color 0.3s",
                    textAlign: "center",
                    color: "#000",
                    position: "relative",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = "#FF5500")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "#ddd")
                  }
                >
                  {option.icon}

                  <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                    {option.label}
                  </span>
                </div>
              </div>
            </OverlayTrigger>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AccountCheck;
